import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const Title = () => {
    useEffect(() => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let interval = null;

        const h1Element = document.querySelector("h1");

        const handleMouseOver = () => {
            let iteration = 0;

            clearInterval(interval);

            interval = setInterval(() => {
                h1Element.innerText = h1Element.innerText
                    .split("")
                    .map((letter, index) => {
                        if (index < iteration) {
                            return h1Element.dataset.value[index];
                        }

                        return letters[Math.floor(Math.random() * 26)];
                    })
                    .join("");

                if (iteration >= h1Element.dataset.value.length) {
                    clearInterval(interval);
                }

                iteration += 1 / 2 ;
            }, 50);
        };
        setTimeout( () => {
            handleMouseOver();
        }, 100);



    }, []);

    return (
        <div className="parent">
            <div className="child">
                <h1 className="h1" data-value="Fexa's Portfolio">Fexa's Portfolio</h1>
                <a href="/portfolio">
                <FontAwesomeIcon  className="icon" icon={faArrowRight}  />
                </a>
                </div>
        </div>
    );
};

export default Title;